import React, { useState, useEffect } from 'react';
import ButtonBack from './images/x.png';
import LotteryTicket from './images/LotteryTicket.png';
import Info from './images/Icon_Info.png';
import { toast } from 'react-hot-toast';
import useSolanaWeb3 from '../hooks/useSolanaWeb3';

function LotteryTicketPopup({ onClose, antShopMintInfo, handleANTShopAssetBuy, fetchBlockchainData }) {
  const [value, setValue] = useState(0);
  const [price, setPrice] = useState(0);
  const [loading, setLoading] = useState(false);
  const {buyTokenFromShop} = useSolanaWeb3();

  const handleInputChange = (event) => {
    const newValue = parseInt(event.target.value);
    if (!isNaN(newValue)) {
      setValue(newValue);
    }
  };

  const handleIncrement = () => {
    if (value < 999) {
      setValue((prevValue) => prevValue + 1);
    }
  };

  const handleDecrement = () => {
    if (value > 0) {
      setValue((prevValue) => prevValue - 1);
    }
  };

  useEffect(() => {
    if (antShopMintInfo) {
      setPrice(antShopMintInfo.price);  // Assuming price is in SOL
    }
  }, [antShopMintInfo]);

  const handleBuyNowButtonClicked = async () => {
    try {
      setLoading(true);
      await buyTokenFromShop(process.env.REACT_APP_LOTTERY_TICKET,value, 100, 4);
      // await handleANTShopAssetBuy("LotteryTicket", value);
      // await fetchBlockchainData();
      toast.success("Transaction was successful");
    } catch (err) {
      console.log("lottery ticket buy error:", err)

      if (err.data && String(err.data.message).includes("insufficient funds")) {
        return toast.error("Insufficient funds")
      }
      switch (true) {
        case String(err).includes("User rejected request"):
          toast.error("User rejected request")
          break;
        case String(err).includes("Marketplace: token address can't be null"):
          toast.error("mint token address can't be null address");
          break;
        case String(err).includes("Marketplace: Insufficient Tokens"):
          toast.error("Insufficient Token Amount");
          break;
        case String(err).includes("Marketplace: You should approve tokens for minting"):
          toast.error("Insufficient Allowance");
          break;
        case String(err).includes("Marketplace: token address can't be null"):
          toast.error("mint token info address can't be null address")
          break;
        default:
          toast.error("Something went wrong!")
          break;
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="popup-container">
      <div className="popup" id="shoppopup">
        <button className="button-close" onClick={onClose}>
          <img src={ButtonBack} alt="Close button" />
        </button>
        <div className="popup-content-left">
          <div className="popupimage-holder">
            <img src={LotteryTicket} alt="LotteryTicket" />
          </div>
        </div>
        <div className="popup-content-right">
          <div className="popupinfo-holder">
          <h2>Lottery ticket</h2>
              <p>Use lottery tickets to participate in the lottery draw!</p>
              <h3>0.0004 SOL</h3>
            <div className="amount-box">
              <button onClick={handleDecrement}>-</button>
              <input
                type="number"
                value={value}
                onChange={handleInputChange}
              />
              <button onClick={handleIncrement}>+</button>
            </div>
            <div className="counter">
              <p>Total:</p>
              <h3>{(value * price / 100).toFixed(4)} $</h3>
            </div>
            <button className="buy-button" onClick={handleBuyNowButtonClicked} disabled={loading}>
              <span>{loading ? "Loading..." : "BUY NOW"}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default LotteryTicketPopup;